import { qs, listen, toggle, contains } from '@fluorescent/dom';
import { section } from '@/glow';

const sel = {
  toggle: '[data-js-toggle]',
  textToggle: '[data-text-toggle]',
};

section('password', {
  onLoad() {
    const toggleButton = qs(sel.toggle, this.container);
    const textToggle = qs(sel.textToggle, this.container);
    const socialButton = qs('[data-social-share]', this.container);

    this.events = [
      listen([toggleButton, textToggle], 'click', e => this.toggleView(e)),
      listen(socialButton, 'click', e => {
        toggle(e.target, 'active');
        const sub = qs('.password__share-icons', e.target);

        sub.setAttribute('aria-hidden', !contains(e.target, 'active'));
      }),
    ];
  },

  toggleView() {
    toggle(this.container, 'welcome');
  },

  onUnload() {
    this.events.forEach(unsubscribe => unsubscribe());
  },
});
